import { graphql } from '@/gql';
import type { GenerateOperatorPerformanceSummaryQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const generateOperatorPerformanceSummary = async ({ callLogId, serviceType }: GenerateOperatorPerformanceSummaryQueryVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      callLogId,
      serviceType,
    },
    query: graphql(`
      query GenerateOperatorPerformanceSummary($callLogId: String!, $serviceType: String!) {
        generateOperatorPerformanceSummary(callLogId: $callLogId, serviceType: $serviceType) {
          summary
        }
      }
    `),
  });

  return response.data.generateOperatorPerformanceSummary;
};
